const moduleName = 'rating';

export function rating () {
    document.querySelectorAll('.js-rating').forEach(el => {
        const mark = el.dataset.rating;
        if (mark) {
            const items = [];
            for (let i = 1; i < 6; i++) {
                const item = document.createElement('span');
                item.className = 'rating__item';
                if (i <= mark) {
                    item.classList.add('rating__item--filled');
                }
                items.push(item);
            }
            el.append(...items);
        }
    });

}
